const route = (event) => {
    event = event || window.event;
    event.preventDefault();
    window.history.pushState({}, "", event.target.href);
    handleLocation();
};

const routes = {
    "/": "./pages/form.html",
    "#live": "./pages/live.html",
    "#perguntas": "./pages/perguntas.html",
    "#acessos": "./pages/acessos.html",
};

const scripts = {
    "/": "/js/form.js",
    "#live": "/js/live.js",
    "#perguntas": "/js/perguntas.js",
    "#acessos": "/js/acessos.js",
};

const isLocalDev = () => {
    const host = window.location.hostname;
    return host === "localhost" || host === "127.0.0.1";
};

const handleLocation = async () => {
    let path = window.location.hash;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const user = urlParams.get('user');
    const ssid = urlParams.get('ssid');

    if(path == "") path = "/";

    // Keep auth guard in production, but allow local visual testing in dev.
    if (path === "#live" && !ssid && !isLocalDev()) {
        window.location.href = './';
        return;
    }

    const route = routes[path] || routes[404];
    const html = await fetch(route).then((data) => data.text());
    document.getElementById("app-main").innerHTML = html;

    // Apply asset src to img elements
    if (window.APP_ASSETS) {
        Object.keys(window.APP_ASSETS).forEach(function(id) {
            var el = document.getElementById(id);
            if (el) el.src = window.APP_ASSETS[id];
        });
    }

    // Apply background-image to div elements
    if (window.APP_BG_ASSETS) {
        Object.keys(window.APP_BG_ASSETS).forEach(function(id) {
            var el = document.getElementById(id);
            if (el) el.style.backgroundImage = 'url("' + window.APP_BG_ASSETS[id] + '")';
        });
    }

    if(scripts[path]){
        let s = document.createElement("script");
        s.type = "text/javascript";
        s.src = "." + scripts[path];
        document.body.prepend(s);
    }
};

window.onpopstate = handleLocation;
window.route = route;

handleLocation();
